module.exports = __webpack_public_path__ + "static/media/carnet_detras.7d83b4fb.JPG";